import apiTest from "../services/apiTest"
const get = key => process.env[key] || ""

export const envThemes = {
  light: {
    primary: get("REACT_APP_LIGHT_PRIMARY") || "#324FA6",
    secondary: get("REACT_APP_LIGHT_SECONDARY") || "#44BF43",
    tertiary: get("REACT_APP_LIGHT_TERTIARY") || "#F2B90C",
    quaternary: get("REACT_APP_LIGHT_QUATERNARY") || "#f2420cff",
    contrast: get("REACT_APP_LIGHT_CONTRAST_TEXT") || "#FFFFFF",
    background: get("REACT_APP_LIGHT_BACKGROUND") || "#FFFFFF",
    textPrimary: get("REACT_APP_LIGHT_TEXT_PRIMARY") || "#2B2B2B",
    textSecondary: get("REACT_APP_LIGHT_TEXT_SECONDARY") || "#737373",
    success: get("REACT_APP_LIGHT_SUCCESS") || "#44BF43",
    paper: get("REACT_APP_LIGHT_PAPER") || "#F8F8F8",
    scrollbarTrack: get("REACT_APP_LIGHT_SCROLLBAR_TRACK") || "#E5E5E5",
    scrollbarThumb: get("REACT_APP_LIGHT_SCROLLBAR_THUMB") || "#324FA6"
  },
  dark: {
    primary: get("REACT_APP_DARK_PRIMARY") || "#324FA6",
    secondary: get("REACT_APP_DARK_SECONDARY") || "#44BF43",
    tertiary: get("REACT_APP_DARK_TERTIARY") || "#F2B90C",
    quaternary: get("REACT_APP_DARK_QUATERNARY") || "#f2420cff",
    contrast: get("REACT_APP_DARK_CONTRAST_TEXT") || "#FFFFFF",
    background: get("REACT_APP_DARK_BACKGROUND") || "#0B141A",
    textPrimary: get("REACT_APP_DARK_TEXT_PRIMARY") || "#FFFFFF",
    textSecondary: get("REACT_APP_DARK_TEXT_SECONDARY") || "#CBCBCB",
    success: get("REACT_APP_DARK_SUCCESS") || "#44BF43",
    paper: get("REACT_APP_DARK_PAPER") || "#0D1628",
    scrollbarTrack: get("REACT_APP_DARK_SCROLLBAR_TRACK") || "#2D43C3",
    scrollbarThumb: get("REACT_APP_DARK_SCROLLBAR_THUMB") || "#5768E0"
  }
}

const CACHE_KEY = "envAssetsCache"
const CACHE_TTL = 1000 * 60 * 60 * 24 // 24h

const fetchAssetsFromAPI = async () => {
  return null //disable temporary
  try {
    const response = await apiTest.get("/get-siteconfig?type=view")
    const data = response?.data
    if (!data) throw new Error("Failed to fetch assets")

    const validData = {
      logo: data.logo || get("REACT_APP_LOGO_URL"),
      logoDark: data.logoDark || get("REACT_APP_LOGO_DARK_URL"),
      favicon: data.favicon || get("REACT_APP_FAVICON_URL"),
      faviconDark: data.faviconDark || get("REACT_APP_FAVICON_DARK_URL"),
      banner: data.banner || get("REACT_APP_BANNER_URL"),
      bucket: get("REACT_APP_BUCKET_URL"),
      fetchedAt: Date.now()
    }

    localStorage.setItem(CACHE_KEY, JSON.stringify(validData))
    return validData
  } catch (error) {
    return null
  }
}

const getCachedAssets = () => {
  const cached = localStorage.getItem(CACHE_KEY)
  if (!cached) return null
  try {
    const parsed = JSON.parse(cached)
    if (Date.now() - parsed.fetchedAt > CACHE_TTL) {
      localStorage.removeItem(CACHE_KEY)
      return null
    }
    return parsed
  } catch {
    localStorage.removeItem(CACHE_KEY)
    return null
  }
}

export const getEnvConfig = (
  mode = process.env.REACT_APP_THEME_MODE || "light"
) => {
  const cached = getCachedAssets()

  const fallback = {
    logo: get("REACT_APP_LOGO_URL"),
    logoDark: get("REACT_APP_LOGO_DARK_URL"),
    favicon: get("REACT_APP_FAVICON_URL"),
    faviconDark: get("REACT_APP_FAVICON_DARK_URL"),
    banner: get("REACT_APP_BANNER_URL"),
    bucket: get("REACT_APP_BUCKET_URL")
  }

  if (!cached) fetchAssetsFromAPI()

  return {
    mode,
    ...envThemes[mode],
    ...(cached || fallback)
  }
}
